import * as FiIcons from 'react-icons/fi';
import SafeIcon from './SafeIcon';

const {FiArrowUpRight} = FiIcons;
const WA = 'https://wa.me/919876543210?text=Hi%20Aurelle!%20I%20am%20ready%20to%20refresh%20my%20wardrobe.';

function FinalCTA() {
  return (
    <section className="relative min-h-[420px] flex flex-col items-center justify-center bg-[#1F1B17] px-6 py-24 text-center overflow-hidden">
      <div className="absolute inset-0 opacity-20">
        <img src="https://images.unsplash.com/photo-1490481651871-ab68de25d43d?auto=format&fit=crop&w=1600&q=70" alt="" className="w-full h-full object-cover" />
      </div>
      <div className="relative z-10">
        <p className="eyebrow eyebrow-center mb-6" style={{color: '#B87333'}}>Your wardrobe called</p>
        <h2 className="font-display text-[clamp(40px,7vw,80px)] leading-[1.05] text-[#F7F2EA] font-light max-w-3xl">
          It wants a little <em className="italic text-[#B87333]">more you.</em>
        </h2>
        <a href={WA} target="_blank" rel="noreferrer" className="btn-gold mt-10 group">
          Begin on WhatsApp <SafeIcon icon={FiArrowUpRight} className="group-hover:translate-x-1 transition" />
        </a>
      </div>
    </section>
  );
}

export default FinalCTA;
